import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../lib/i18n";
import { CATEGORIES } from "../lib/format";

export default function Footer() {
  const { lang } = useLang();
  return (
    <footer className="relative z-10 border-t border-white/10 bg-[#0A0A0A] mt-20">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-10 relative z-10">
        <div className="col-span-2 md:col-span-1">
          <span className="text-gold text-2xl font-display">KOILA <span className="text-base text-white/50">Holdings</span></span>
          <p className="text-white/40 text-sm mt-3 max-w-xs leading-relaxed">
            {lang === "en"
              ? "Cameroon's premium marketplace for land, property, vehicles and modular structures."
              : "La marketplace premium du Cameroun pour terrains, biens, véhicules et structures modulaires."}
          </p>
          <a href="mailto:info@koilaholdings.com" data-testid="footer-email" className="text-gold text-sm mt-4 inline-block hover:opacity-80 transition-opacity">info@koilaholdings.com</a>
        </div>
        <div>
          <h4 className="text-white/80 text-sm font-medium mb-4 uppercase tracking-wider">{lang === "en" ? "Categories" : "Catégories"}</h4>
          <ul className="space-y-2">
            {CATEGORIES.map((c) => (
              <li key={c.key}>
                <Link to={`/browse?category=${c.key}`} className="text-white/40 hover:text-gold text-sm transition-colors">{c[lang]}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-white/80 text-sm font-medium mb-4 uppercase tracking-wider">{lang === "en" ? "Company" : "Entreprise"}</h4>
          <ul className="space-y-2 text-white/40 text-sm">
            <li><Link to="/about" data-testid="footer-about" className="hover:text-gold transition-colors">{lang === "en" ? "About us" : "À propos"}</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors">{lang === "en" ? "How it works" : "Comment ça marche"}</Link></li>
            <li><a href="mailto:info@koilaholdings.com" className="hover:text-gold transition-colors">{lang === "en" ? "Contact" : "Contact"}</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white/80 text-sm font-medium mb-4 uppercase tracking-wider">{lang === "en" ? "Support" : "Support"}</h4>
          <ul className="space-y-2 text-white/40 text-sm">
            <li><Link to="/help" data-testid="footer-help" className="hover:text-gold transition-colors">{lang === "en" ? "Help center" : "Centre d'aide"}</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-gold transition-colors">{lang === "en" ? "Terms" : "Conditions"}</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-gold transition-colors">{lang === "en" ? "Privacy" : "Confidentialité"}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/30 text-xs">
        © {new Date().getFullYear()} Koila Holdings. {lang === "en" ? "All rights reserved." : "Tous droits réservés."}
      </div>
    </footer>
  );
}
